(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advantage-block"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.pure-temp-glass-block').forEach(function(element) {
      element.addEventListener('click', function() {
        var target = this.getAttribute('data-target');
        var arrow = this.querySelector('.faq-arrow');
        var collapseContent = document.querySelector(target);
        
        // Toggle the rotate class and color
        arrow.classList.toggle('rotate');
        
        // Toggle collapse state
        if (collapseContent.classList.contains('show')) {
          collapseContent.classList.remove('show');
        } else {
          // Close other open FAQs
          document.querySelectorAll('.sand-glass-block.show').forEach(function(openContent) {
            openContent.classList.remove('show');
            var openArrow = document.querySelector(`[data-target="#${openContent.id}"] .faq-arrow`);
            if (openArrow) openArrow.classList.remove('rotate');
          });
          collapseContent.classList.add('show');
        }
      });
    });

    document.querySelectorAll('.wait-temp').forEach(function(element) {
      element.addEventListener('click', function() {
        var target = this.getAttribute('data-target');
        var collapseContent = document.querySelector(target);
        var arrow = document.querySelector(`[data-target="${target}"] .faq-arrow`);
        
        // Toggle the rotate class and color
        arrow.classList.toggle('rotate');
        
        // Toggle collapse state
        if (collapseContent.classList.contains('show')) {
          collapseContent.classList.remove('show');
        } else {
          // Close other open FAQs
          document.querySelectorAll('.sand-glass-block.show').forEach(function(openContent) {
            openContent.classList.remove('show');
            var openArrow = document.querySelector(`[data-target="#${openContent.id}"] .faq-arrow`);
            if (openArrow) openArrow.classList.remove('rotate');
          });
          collapseContent.classList.add('show');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-landing-page-main-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
  dropdownToggles.forEach(btn => {
    btn.addEventListener("click", function () {
      this.nextElementSibling.classList.toggle("show");
      this.classList.toggle("dropdown-style");
    });
  });

  const playBtn = document.querySelector(".playvideo-show-land");
  const iFrame = document.getElementById("iFrame3");
  const videoBg = document.querySelector(".video-background3");
  const closeBtn = document.querySelector(".close3");
  const youtubeVideo = document.getElementById("youtube-video3");

  const toggleVideo = (play) => {
    iFrame.classList.toggle("show");
    videoBg.classList.toggle("show");
    const command = play ? "playVideo" : "pauseVideo";
    youtubeVideo.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: command, args: "" }),
      "*"
    );
  };

  playBtn?.addEventListener("click", () => toggleVideo(true));
  closeBtn?.addEventListener("click", () => toggleVideo(false));
  videoBg?.addEventListener("click", () => toggleVideo(false));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-mixed-media-grid"] && !Shopify.designMode) return;
  try {
    
function setupMixedMediaGridEvents(container) {
  const triggers = container.querySelectorAll('[data-modal-target]');
  const modals = container.querySelectorAll('[data-modal]');

  const stopVideo = (modal) => {
    const iframe = modal.querySelector('iframe');
    const video = modal.querySelector('video');
    if (iframe) {
      const originalSrc = iframe.getAttribute('data-original-src');
      iframe.src = '';
      if (originalSrc) {
        let cleanSrc = originalSrc.replace(/(\?|&)autoplay=1/, '');
        iframe.src = cleanSrc;
      }
    }
    if (video) { video.pause(); video.currentTime = 0; }
  };

  const openModal = (modal) => {
    modal.classList.add('is-active');
    const iframe = modal.querySelector('iframe');
    const video = modal.querySelector('video');
    if (iframe) {
      if (!iframe.hasAttribute('data-original-src')) { iframe.setAttribute('data-original-src', iframe.src); }
      if (!iframe.src.includes('autoplay=1')) { iframe.src += iframe.src.includes('?') ? '&autoplay=1' : '?autoplay=1'; }
    }
    if (video) { video.play(); }
  };

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = document.getElementById(trigger.dataset.modalTarget);
      if (modal) openModal(modal);
    });
  });

  document.querySelectorAll('[data-modal-close]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = btn.closest('[data-modal]');
      if (modal) { modal.classList.remove('is-active'); stopVideo(modal); }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mixed-media-grid-wrapper').forEach(section => setupMixedMediaGridEvents(section));

  document.querySelectorAll('.mmg-view-more').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.mixed-media-grid-wrapper');
      wrapper.querySelectorAll('.hide-on-mobile').forEach(card => card.classList.remove('hide-on-mobile'));
      btn.style.display = 'none';
    });
  });
});

document.addEventListener('shopify:section:load', (e) => {
  const sectionWrapper = e.target.querySelector('.mixed-media-grid-wrapper');
  if (sectionWrapper) setupMixedMediaGridEvents(sectionWrapper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["play-button-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const playButtons = document.querySelectorAll('.playvideo-show');
  const closeButton = document.querySelector('.tabitha-close');
  const videoBackground = document.querySelector('.video-background');
  const iframe = document.getElementById('iFrame');
  const youtubeIframe = document.getElementById('youtube-video');

  playButtons.forEach(button => {
    button.addEventListener('click', function() {
      iframe.classList.toggle("show");
      videoBackground.classList.toggle('show');
      youtubeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
  });

  closeButton.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  videoBackground.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-banner-dropdown"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const playButtons = document.querySelectorAll('.playvideo-show');
  const closeButton = document.querySelector('.tabitha-close');
  const videoBackground = document.querySelector('.video-background');
  const iframe = document.getElementById('iFrame');
  const youtubeIframe = document.getElementById('youtube-video');
  const deviceSelects = document.querySelectorAll('.device-select');

  playButtons.forEach(button => {
    button.addEventListener('click', function() {
      iframe.classList.toggle("show");
      videoBackground.classList.toggle('show');
      youtubeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
  });

  closeButton.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  videoBackground.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  deviceSelects.forEach(select => {
    select.addEventListener('change', function() {
      const url = this.value;
      if (url) {
        window.location.href = url;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const playButtons = document.querySelectorAll('.playvideo-show');
  const closeButton = document.querySelector('.tabitha-close');
  const videoBackground = document.querySelector('.video-background');
  const iframe = document.getElementById('iFrame');
  const youtubeIframe = document.getElementById('youtube-video');

  playButtons.forEach(button => {
    button.addEventListener('click', function() {
      iframe.classList.toggle("show");
      videoBackground.classList.toggle('show');
      youtubeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
  });

  closeButton.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  videoBackground.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
});

  } catch(e) { console.error(e); }
})();
})();
